import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-info"
}
const _hoisted_2 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_popover = _resolveComponent("popover")!

  return (_ctx.displayExport || _ctx.displayImport || _ctx.exportError || _ctx.importError)
    ? (_openBlock(), _createBlock(_component_popover, {
        key: 0,
        trigger: "hover",
        placement: "left",
        viewport: "#section-content",
        "append-to": "#section-content",
        "position-by": "#section-main"
      }, {
        popover: _withCtx(() => [
          (_ctx.displayExport)
            ? (_openBlock(), _createElementBlock("dl", _hoisted_3, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$t("scm.export.title")), 1),
                _createElementVNode("dd", null, _toDisplayString(_ctx.exportMessage), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.displayImport)
            ? (_openBlock(), _createElementBlock("dl", _hoisted_4, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$t("scm.import.title")), 1),
                _createElementVNode("dd", null, _toDisplayString(_ctx.importMessage), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.exportError)
            ? (_openBlock(), _createElementBlock("dl", _hoisted_5, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$t("scm.export.title")), 1),
                _createElementVNode("dd", null, _toDisplayString(_ctx.exportErrorText), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.importError)
            ? (_openBlock(), _createElementBlock("dl", _hoisted_6, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$t("scm.import.title")), 1),
                _createElementVNode("dd", null, _toDisplayString(_ctx.importErrorText), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          (_ctx.displayExportState || _ctx.displayImportState)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _cache[0] || (_cache[0] = _createElementVNode("i", { class: "glyphicon glyphicon-exclamation-sign" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.defaultDisplayText), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.exportError || _ctx.importError)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                _cache[1] || (_cache[1] = _createElementVNode("i", { class: "glyphicon glyphicon-exclamation-sign" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("scm.status.ERROR.display.text")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}